(function (window) {
  /**
   * Given a BatchGeoStoreLocatorListItem it will allow you to render a
   * thumbnail of the list item's location if possible. If not it will render
   * a placeholder div.
   *
   * @example
   * // The component requires a list item instance so get that
   * var listItem = BatchGeoStoreLocatorListItem({});
   *
   * // Now pass the instance in and you'll get a thumbnail to render
   * var markerThumbnail = new window.BatchGeoStoreLocatorMarkerThumbnail(listItem);
   *
   * // Will render either a div placeholder if no thumbnail or an img if
   * // there is a thumbnail to render.
   * $('.example').append(markerThumbnail.render())
   *
   * @param {BatchGeoStoreLocatorListItem} listItemInstance The thumbnail is
   * created based on the properties in locator list item so you must pass a
   * reference in.
   *
   * @return {BatchGeoStoreLocatorMarkerThumbnail}
   *
   * @constructor
   */
  var BatchGeoStoreLocatorMarkerThumbnail = function (listItemInstance) {
    this.listItemInstance = listItemInstance;
    return this;
  };

  /**
   * If there is a thumbnail to display it renders an image of it. Otherwise
   * it render sa div as a placeholder. The thumbnail or placeholder is
   * wrapped in a div so you know you will always get a jQuery div element.
   *
   * @return {jQuery} Returns a jQuery div element.
   */
  BatchGeoStoreLocatorMarkerThumbnail.prototype.render = function () {
    var thumbnailUrl = this.listItemInstance.getModel().thumbnail;
    var thumbnailTag = thumbnailUrl ? "img" : "div";

    var thumbnailElement = $("<" + thumbnailTag + " />", {
      class: "storeLocator-thumbnail-image lazy-storeLocator-image",
      "data-src": thumbnailUrl,
    });

    return $("<div />", {
      class: "markerLocator-thumbnail",
      html: [thumbnailElement],
    });
  };

  window.BatchGeoStoreLocatorMarkerThumbnail =
    BatchGeoStoreLocatorMarkerThumbnail;
})(window);
